import OnlineBookingSwitch from "../../components/OnlineBookingSwitch";
import OrganizerTimePillSelect from "../../components/OrganizerTimePillSelect";
import "../../components/EventFormPickers.css";
import AvisoSenasBloqueadas from "../../components/AvisoSenasBloqueadas";
import { Dinero, alternar } from "../../canchas/primerUso/clubPasos";
import {
	BloqueUbicacion,
	Campo,
	PasoContacto,
	PasoFotos,
	PasoPoliticas,
} from "../../reservas/primerUso/barPasos";
import {
	DIAS_SEMANA,
	clavesVigentes,
	faltaContactoSalon,
	faltaEquipo,
	faltaHorarios,
	faltaReserva,
	faltaSalon,
	faltaServicios,
	hayCobroAnticipado,
	horarioDelPro,
	nuevoProfesional,
	nuevoServicio,
	parcheHorario,
} from "./salonPayload";

const DIAS_TXT = (dias) =>
	dias.length === 7
		? "Todos los días"
		: DIAS_SEMANA.filter((x) => dias.includes(x.weekday))
				.map((x) => x.corto)
				.join(" ");
const plata = (n) => `$ ${Number(n || 0).toLocaleString("es-AR")}`;

/* ---- 1. Tu salón ---- */
export const PasoSalon = ({ data: d, set, states }) => (
	<>
		<Campo
			label="Nombre del salón"
			hint={
				d.nombreDelPortal && d.nombre === d.nombreDelPortal
					? "Del portal. Podés cambiarlo."
					: undefined
			}
		>
			<input
				className="ef-input"
				value={d.nombre}
				onChange={(e) => set({ nombre: e.target.value })}
				placeholder="Ej: Estudio Luna"
			/>
		</Campo>
		<BloqueUbicacion data={d} set={set} states={states} entityLabel="salón" />
	</>
);

/* ---- 2. ¿Cuándo atendés? ---- */
const PasoHorarios = ({ data: d, set }) => (
	<>
		<div className="zr-field">
			<span className="zr-field__label">Días que abrís</span>
			<div className="zr-week pu-week">
				{DIAS_SEMANA.map((x) => {
					const on = d.dias.includes(x.weekday);
					return (
						<button
							key={x.weekday}
							type="button"
							aria-pressed={on}
							aria-label={x.largo}
							className={"zr-week__day" + (on ? " zr-week__day--on" : "")}
							onClick={() => set({ dias: alternar(d.dias, x.weekday) })}
						>
							{x.corto}
						</button>
					);
				})}
			</div>
		</div>
		<div className="pu-times">
			<div className="zr-field">
				<span className="zr-field__label">Abre</span>
				<OrganizerTimePillSelect
					triggerClassName="zr-day-row__time"
					ariaLabel="Abre"
					value={d.desde}
					onChange={(val) => set({ desde: val })}
					quarterHours
				/>
			</div>
			<div className="zr-field">
				<span className="zr-field__label">Cierra</span>
				<OrganizerTimePillSelect
					triggerClassName="zr-day-row__time"
					ariaLabel="Cierra"
					value={d.hasta}
					onChange={(val) => set({ hasta: val })}
					quarterHours
				/>
			</div>
		</div>
		<p className="ef-footnote">
			Es el horario del salón. Cada profesional puede tener el suyo en el paso
			del equipo.
		</p>
	</>
);

/* ---- 3. Tus servicios ---- */
const PasoServicios = ({ data: d, set, senasBloqueadas }) => {
	const setServicio = (i, patch) =>
		set({
			servicios: d.servicios.map((s, j) => (j === i ? { ...s, ...patch } : s)),
		});
	return (
		<>
			{senasBloqueadas && <AvisoSenasBloqueadas />}
			{d.servicios.length === 0 ? (
				<p className="pu-empty">
					No tenés servicios cargados. Sumá el primero con su duración y su
					precio.
				</p>
			) : (
				<div className="pu-scroll">
					<table className="pu-table pu-table--servicios">
						<thead>
							<tr>
								<th>Servicio</th>
								<th style={{ width: 150 }}>Categoría (opcional)</th>
								<th style={{ width: 110 }}>Duración (min)</th>
								<th style={{ width: 130 }}>Precio</th>
								<th style={{ width: 130 }}>Seña (opcional)</th>
								<th style={{ width: 40 }} />
							</tr>
						</thead>
						<tbody>
							{d.servicios.map((s, i) => (
								<tr key={s.key}>
									<td>
										<input
											className="ef-input"
											aria-label="Nombre del servicio"
											value={s.nombre}
											placeholder="Ej: Corte de pelo"
											onChange={(e) =>
												setServicio(i, { nombre: e.target.value })
											}
										/>
									</td>
									<td>
										<input
											className="ef-input"
											aria-label={`Categoría de ${s.nombre || "servicio"}`}
											value={s.categoria}
											placeholder="Ej: Peluquería"
											onChange={(e) =>
												setServicio(i, { categoria: e.target.value })
											}
										/>
									</td>
									<td>
										<input
											className="ef-input"
											type="number"
											min="5"
											step="5"
											aria-label={`Duración de ${s.nombre || "servicio"} (min)`}
											value={s.duracion}
											onChange={(e) =>
												setServicio(i, { duracion: e.target.value })
											}
										/>
									</td>
									<td>
										<Dinero
											label={`Precio de ${s.nombre || "servicio"}`}
											value={s.precio}
											onChange={(v) => setServicio(i, { precio: v })}
										/>
									</td>
									<td>
										<Dinero
											label={`Seña de ${s.nombre || "servicio"}`}
											value={s.sena}
											placeholder="Sin seña"
											disabled={senasBloqueadas}
											onChange={(v) => setServicio(i, { sena: v })}
										/>
									</td>
									<td>
										<button
											type="button"
											className="ef-btn ef-btn--ghost"
											aria-label={`Quitar ${s.nombre || "servicio"}`}
											onClick={() =>
												set({
													servicios: d.servicios.filter((_, j) => j !== i),
												})
											}
										>
											×
										</button>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			)}
			<div className="pu-row-actions">
				<button
					type="button"
					className="ef-btn ef-btn--ghost"
					onClick={() => set({ servicios: [...d.servicios, nuevoServicio()] })}
				>
					Agregar servicio
				</button>
			</div>
			<p className="ef-hint">
				Te dejamos algunos de ejemplo: cambiá nombre, duración y precio, o
				borralos. No se guarda nada hasta que termines.
			</p>
			<p className="ef-hint">
				La duración va de a 5 minutos. La seña se cobra al reservar cuando tus
				cobros están validados.
			</p>
		</>
	);
};

/* ---- 4. Tu equipo ---- */
const nombreDe = (p, i) => p.nombre.trim() || `Profesional ${i + 1}`;
const iniciales = (p) => (p.nombre.trim()[0] || "?").toUpperCase();

const TarjetaPro = ({ p, i, d, onNombre, onEspecialidad, onQuitar }) => {
	const n = clavesVigentes(p, d).length;
	return (
		<div className="pu-pro-card">
			<div className="pu-row-actions">
				<span className="pu-avatar" aria-hidden="true">
					{iniciales(p)}
				</span>
				<small className="pu-pro-card__count">
					{n} {n === 1 ? "servicio" : "servicios"}
				</small>
				<button
					type="button"
					className="ef-btn ef-btn--ghost pu-pro-card__remove"
					aria-label={`Quitar a ${nombreDe(p, i)}`}
					onClick={onQuitar}
				>
					×
				</button>
			</div>
			<Campo label="Nombre">
				<input
					className="ef-input"
					aria-label="Nombre del profesional"
					value={p.nombre}
					placeholder="Ej: Lucía Pérez"
					onChange={(e) => onNombre(e.target.value)}
				/>
			</Campo>
			<Campo label="Especialidad (opcional)">
				<input
					className="ef-input"
					aria-label="Especialidad del profesional"
					value={p.especialidad || ""}
					maxLength={60}
					placeholder="Ej: Estilista y colorista"
					onChange={(e) => onEspecialidad(e.target.value)}
				/>
			</Campo>
		</div>
	);
};

const MatrizServicios = ({ d, setPro }) => (
	<div className="pu-scroll">
		<table className="pu-table pu-matrix">
			<thead>
				<tr>
					<th scope="col">Servicio</th>
					{d.equipo.map((p, i) => (
						<th key={p.key} scope="col" className="pu-matrix__pro">
							{nombreDe(p, i)}
						</th>
					))}
				</tr>
			</thead>
			<tbody>
				{d.servicios.map((s) => (
					<tr key={s.key}>
						<td>
							<b>{s.nombre || "Servicio sin nombre"}</b>
							<small className="pu-matrix__meta">{s.duracion} min</small>
						</td>
						{d.equipo.map((p, i) => {
							const vigentes = clavesVigentes(p, d);
							return (
								<td key={p.key} className="pu-matrix__cell">
									<input
										type="checkbox"
										aria-label={`${nombreDe(p, i)} hace ${s.nombre || "servicio sin nombre"}`}
										checked={vigentes.includes(s.key)}
										onChange={() =>
											setPro(i, { serviceKeys: alternar(vigentes, s.key) })
										}
									/>
								</td>
							);
						})}
					</tr>
				))}
			</tbody>
		</table>
	</div>
);

const HorarioPro = ({ p, i, d, setPro }) => {
	const nombre = nombreDe(p, i);
	const horario = horarioDelPro(p, d);
	const abierto = horario.find((h) => h.enabled);
	const open = abierto?.open || d.desde;
	const close = abierto?.close || d.hasta;
	const guardar = (nuevo) => setPro(i, parcheHorario(nuevo, d));
	return (
		<div className="pu-pro-hours">
			<b className="pu-pro-hours__name">{nombre}</b>
			<div className="zr-week pu-week pu-pro-days">
				{DIAS_SEMANA.map((x) => {
					const h = horario.find((y) => y.weekday === x.weekday);
					const cierra = !d.dias.includes(x.weekday);
					return (
						<button
							key={x.weekday}
							type="button"
							disabled={cierra}
							aria-pressed={h.enabled}
							aria-label={`${x.largo} de ${nombre}${cierra ? " (el salón cierra)" : ""}`}
							className={
								"zr-week__day" + (h.enabled ? " zr-week__day--on" : "")
							}
							onClick={() =>
								guardar(
									horario.map((y) =>
										y.weekday === x.weekday
											? { ...y, enabled: !y.enabled, open, close }
											: y,
									),
								)
							}
						>
							{x.corto}
						</button>
					);
				})}
			</div>
			<div className="pu-pro-hours__times">
				<OrganizerTimePillSelect
					className="pu-time-fixed"
					triggerClassName="zr-day-row__time"
					ariaLabel={`Desde de ${nombre}`}
					value={open}
					quarterHours
					onChange={(val) => guardar(horario.map((y) => ({ ...y, open: val })))}
				/>
				<span>a</span>
				<OrganizerTimePillSelect
					className="pu-time-fixed"
					triggerClassName="zr-day-row__time"
					ariaLabel={`Hasta de ${nombre}`}
					value={close}
					quarterHours
					onChange={(val) =>
						guardar(horario.map((y) => ({ ...y, close: val })))
					}
				/>
			</div>
		</div>
	);
};

const PasoEquipo = ({ data: d, set }) => {
	const setPro = (i, patch) =>
		set({ equipo: d.equipo.map((p, j) => (j === i ? { ...p, ...patch } : p)) });
	return (
		<>
			{d.equipo.length === 0 && (
				<p className="pu-empty">
					Todavía no sumaste a nadie. Agregá a cada profesional y marcá qué
					servicios hace.
				</p>
			)}
			<div className="pu-pro-grid">
				{d.equipo.map((p, i) => (
					<TarjetaPro
						key={p.key}
						p={p}
						i={i}
						d={d}
						onNombre={(nombre) => setPro(i, { nombre })}
						onEspecialidad={(especialidad) => setPro(i, { especialidad })}
						onQuitar={() => set({ equipo: d.equipo.filter((_, j) => j !== i) })}
					/>
				))}
				<button
					type="button"
					className="pu-pro-add"
					onClick={() => set({ equipo: [...d.equipo, nuevoProfesional()] })}
				>
					<span aria-hidden="true">+</span>Agregar profesional
				</button>
			</div>
			{d.equipo.length > 0 && (
				<>
					<section className="pu-body" aria-label="¿Quién hace qué?">
						<h3 className="pu-subtitle">¿Quién hace qué?</h3>
						<p className="ef-hint">
							En el sitio, tus clientes solo ven a los profesionales que hacen
							todos los servicios que eligieron.
						</p>
						{d.servicios.length > 0 && (
							<MatrizServicios d={d} setPro={setPro} />
						)}
					</section>
					<section className="pu-body" aria-label="Horario de cada profesional">
						<h3 className="pu-subtitle">Horario de cada profesional</h3>
						<p className="ef-hint">
							Siempre dentro del horario del salón ({DIAS_TXT(d.dias) || "—"},
							de {d.desde} a {d.hasta}).
						</p>
						<div className="pu-pro-hours-list">
							{d.equipo.map((p, i) => (
								<HorarioPro key={p.key} p={p} i={i} d={d} setPro={setPro} />
							))}
						</div>
						<p className="ef-footnote">
							Un tramo por día. Después, en Profesionales, podés cargar más de
							uno.
						</p>
					</section>
				</>
			)}
		</>
	);
};

/* ---- 5. ¿Cómo se reserva? ---- */
const PasoReserva = ({ data: d, set, senasBloqueadas }) => (
	<div className="pu-split">
		<div className="pu-body">
			<OnlineBookingSwitch
				checked={d.onlineBookingEnabled}
				onChange={(onlineBookingEnabled) => set({ onlineBookingEnabled })}
			/>
			<p className="ef-hint">
				{!hayCobroAnticipado(d)
					? "No cargaste señas: tus clientes reservan sin pagar. Si después sumás una seña a un servicio, se cobra al reservar cuando tus cobros están validados."
					: senasBloqueadas
						? "Las señas que cargaste quedan guardadas y se cobran al reservar apenas tus cobros estén validados en ZOCO Pagos."
						: "Tus clientes pagan al reservar la seña de cada servicio que la tenga."}
			</p>
			<PasoPoliticas data={d} set={set} conVentana />
		</div>
		<aside className="pu-summary" aria-label="Resumen">
			<dl style={{ margin: 0 }}>
				<dt>Salón</dt>
				<dd>
					{d.nombre || "—"}
					<br />
					{d.address || "—"}
				</dd>
				<dt>Horario</dt>
				<dd>
					{DIAS_TXT(d.dias) || "—"} · {d.desde} a {d.hasta}
				</dd>
				<dt>Servicios</dt>
				<dd>
					{d.servicios.map((s) => (
						<div key={s.key}>
							{s.nombre || "—"} · {s.duracion} min · {plata(s.precio)}
						</div>
					))}
				</dd>
				<dt>Equipo</dt>
				<dd>
					{d.equipo.map((p) => (
						<div key={p.key}>{p.nombre || "—"}</div>
					))}
				</dd>
				<dt>Seña</dt>
				<dd>{hayCobroAnticipado(d) ? "Se cobra al reservar" : "Sin seña"}</dd>
			</dl>
		</aside>
	</div>
);

/* ---- Optional: contact + description ---- */
export const PasoContactoSalon = (p) => (
	<PasoContacto {...p} lugar="salón" ejemplo="salon" />
);

export const pasosSalon = ({ states, senasBloqueadas }) => ({
	req: [
		{
			id: "salon",
			titulo: "Tu salón",
			bajada:
				"El nombre viene del portal y lo podés cambiar. La ubicación es la que ven tus clientes en el mapa.",
			render: (p) => <PasoSalon {...p} states={states} />,
			falta: faltaSalon,
		},
		{
			id: "horarios",
			titulo: "¿Cuándo atendés?",
			bajada:
				"Los días y el horario de apertura del salón. Los turnos se arman dentro de ese horario.",
			render: (p) => <PasoHorarios {...p} />,
			falta: faltaHorarios,
		},
		{
			id: "servicios",
			titulo: "Tus servicios",
			bajada:
				"Cada servicio con su duración y su precio. Son ejemplos para que arranques rápido: editalos, borralos o sumá los tuyos.",
			render: (p) => <PasoServicios {...p} senasBloqueadas={senasBloqueadas} />,
			falta: faltaServicios,
		},
		{
			id: "equipo",
			titulo: "Tu equipo",
			bajada:
				"Quién atiende, qué servicios hace cada uno y cuándo trabaja. Si trabaja en el horario del salón, no tenés que tocar nada más.",
			render: (p) => <PasoEquipo {...p} />,
			falta: faltaEquipo,
		},
		{
			id: "reserva",
			titulo: "¿Cómo se reserva?",
			final: "Abrir turnos",
			bajada:
				"Las reglas para reservar y cancelar. Si cargaste señas en tus servicios, se cobran al reservar.",
			render: (p) => <PasoReserva {...p} senasBloqueadas={senasBloqueadas} />,
			falta: faltaReserva,
		},
	],
	opc: [
		{
			id: "contacto",
			titulo: "Contacto y descripción",
			seccion: "Salón",
			bajada:
				"Lo que ven tus clientes en la página del salón para conocerte y escribirte.",
			render: (p) => <PasoContactoSalon {...p} />,
			falta: faltaContactoSalon,
		},
		{
			id: "fotos",
			titulo: "Fotos del salón",
			seccion: "Salón",
			bajada:
				"La portada encabeza la página del salón; la galería muestra el lugar y tus trabajos.",
			render: (p) => <PasoFotos {...p} />,
			falta: () => "",
		},
	],
});
